var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttemptDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19238 15.7115L10.8078 15.7115",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46143 12.25L12.5384 12.25",
    stroke: "#74767B",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78857 1V5.52308C8.78857 6.36316 8.78857 6.7832 8.95206 7.10406C9.09587 7.38631 9.32535 7.61578 9.60759 7.75959C9.92846 7.92308 10.3485 7.92308 11.1886 7.92308H15.7117",
    stroke: "#74767B",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.4C1 2.55992 1 2.13988 1.16349 1.81901C1.3073 1.53677 1.53677 1.3073 1.81901 1.16349C2.13988 1 2.55992 1 3.4 1H9.23666C9.60354 1 9.78699 1 9.95962 1.04145C10.1127 1.07819 10.259 1.1388 10.3932 1.22104C10.5446 1.3138 10.6743 1.44352 10.9337 1.70294L15.2971 6.06629C15.5565 6.32571 15.6862 6.45543 15.779 6.6068C15.8612 6.74101 15.9218 6.88733 15.9586 7.04038C16 7.21301 16 7.39646 16 7.76334V18.2154C16 19.0555 16 19.4755 15.8365 19.7964C15.6927 20.0786 15.4632 20.3081 15.181 20.4519C14.8601 20.6154 14.4401 20.6154 13.6 20.6154H3.4C2.55992 20.6154 2.13988 20.6154 1.81901 20.4519C1.53677 20.3081 1.3073 20.0786 1.16349 19.7964C1 19.4755 1 19.0555 1 18.2154V3.4Z",
    stroke: "#74767B",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptDate);
export default __webpack_public_path__ + "static/media/attemptDate.ddad4aad06db9498300fd6a25b80985b.svg";
export { ForwardRef as ReactComponent };